import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete } from "../../../utils/axios";
import * as actions from "./actions";

// ==================== INGREDIENTS ====================

function* fetchIngredients(action) {
    try {
        const filters = action.payload || {};
        const queryParams = new URLSearchParams();

        Object.keys(filters).forEach(key => {
            if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                queryParams.append(key, filters[key]);
            }
        });

        const queryString = queryParams.toString();
        const url = `/mycore/ingredients/${queryString ? `?${queryString}` : ''}`;

        const result = yield call(AxiosCall, url);
        yield put(actions.fetchIngredientsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchIngredientsFailure(e.message));
    }
}

function* fetchIngredientDetail(action) {
    try {
        const { ingredientId } = action.payload;
        const result = yield call(AxiosCall, `/mycore/ingredients/${ingredientId}/`);
        yield put(actions.fetchIngredientDetailSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchIngredientDetailFailure(e.message));
    }
}

// ==================== CREATE/UPDATE/DELETE ====================

function* createIngredient(action) {
    try {
        const result = yield call(AxiosPost, '/mycore/ingredients/', action.payload);
        yield put(actions.createIngredientSuccess(result.data));
    } catch (e) {
        yield put(actions.createIngredientFailure(e.message));
    }
}

function* updateIngredient(action) {
    try {
        const { ingredientId, ingredientData } = action.payload;
        const result = yield call(AxiosPatch, `/mycore/ingredients/${ingredientId}/`, ingredientData);
        yield put(actions.updateIngredientSuccess(result.data));
    } catch (e) {
        yield put(actions.updateIngredientFailure(e.message));
    }
}

function* deleteIngredient(action) {
    try {
        const { ingredientId } = action.payload;
        yield call(AxiosDelete, `/mycore/ingredients/${ingredientId}/`);
        yield put(actions.deleteIngredientSuccess(ingredientId));
    } catch (e) {
        yield put(actions.deleteIngredientFailure(e.message));
    }
}

// ==================== ADMIN ACTIONS ====================

function* fetchPendingIngredients() {
    try {
        const result = yield call(AxiosCall, '/mycore/ingredients/pending/');
        yield put(actions.fetchPendingIngredientsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchPendingIngredientsFailure(e.message));
    }
}

function* approveIngredient(action) {
    try {
        const { ingredientId, notes } = action.payload;
        const body = notes ? { notes } : {};
        const result = yield call(AxiosPost, `/mycore/ingredients/${ingredientId}/approve/`, body);
        yield put(actions.approveIngredientSuccess(result.data));
    } catch (e) {
        yield put(actions.approveIngredientFailure(e.message));
    }
}

function* rejectIngredient(action) {
    try {
        const { ingredientId, notes } = action.payload;
        const body = notes ? { notes } : {};
        const result = yield call(AxiosPost, `/mycore/ingredients/${ingredientId}/reject/`, body);
        yield put(actions.rejectIngredientSuccess(result.data));
    } catch (e) {
        yield put(actions.rejectIngredientFailure(e.message));
    }
}

function* promoteIngredient(action) {
    try {
        const { ingredientId, notes } = action.payload;
        const body = notes ? { notes } : {};
        const result = yield call(AxiosPost, `/mycore/ingredients/${ingredientId}/promote/`, body);
        yield put(actions.promoteIngredientSuccess(result.data));
    } catch (e) {
        yield put(actions.promoteIngredientFailure(e.message));
    }
}

// ==================== WATCHERS ====================

function* watchFetchIngredients() {
    yield takeLatest(actions.FETCH_INGREDIENTS.REQUEST, fetchIngredients);
}

function* watchFetchIngredientDetail() {
    yield takeLatest(actions.FETCH_INGREDIENT_DETAIL.REQUEST, fetchIngredientDetail);
}

function* watchCreateIngredient() {
    yield takeEvery(actions.CREATE_INGREDIENT.REQUEST, createIngredient);
}

function* watchUpdateIngredient() {
    yield takeEvery(actions.UPDATE_INGREDIENT.REQUEST, updateIngredient);
}

function* watchDeleteIngredient() {
    yield takeEvery(actions.DELETE_INGREDIENT.REQUEST, deleteIngredient);
}

function* watchFetchPendingIngredients() {
    yield takeLatest(actions.FETCH_PENDING_INGREDIENTS.REQUEST, fetchPendingIngredients);
}

function* watchApproveIngredient() {
    yield takeEvery(actions.APPROVE_INGREDIENT.REQUEST, approveIngredient);
}

function* watchRejectIngredient() {
    yield takeEvery(actions.REJECT_INGREDIENT.REQUEST, rejectIngredient);
}

function* watchPromoteIngredient() {
    yield takeEvery(actions.PROMOTE_INGREDIENT.REQUEST, promoteIngredient);
}

// ==================== ROOT SAGA ====================

export default function* ingredientsSaga() {
    yield all([
        watchFetchIngredients(),
        watchFetchIngredientDetail(),
        watchCreateIngredient(),
        watchUpdateIngredient(),
        watchDeleteIngredient(),
        watchFetchPendingIngredients(),
        watchApproveIngredient(),
        watchRejectIngredient(),
        watchPromoteIngredient(),
    ]);
}
